"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTenant = exports.TenantContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TenantContext = exports.TenantContext = /*#__PURE__*/_react["default"].createContext();
var useTenant = exports.useTenant = function useTenant() {
  var context = _react["default"].useContext(TenantContext);
  if (context === undefined || context === null) {
    throw new Error("useTenant must be used within a Tenant Provider");
  }
  return context;
};